import React, { useState,useEffect, useMemo, Fragment } from "react";
import { Link, useNavigate,useParams } from 'react-router-dom'
import axios from "axios";
import { schoolsurl, foreignexchangelists, eligibility,schoolsApiurl, FileUploadAthletURL } from "../../../apis/urls";
import moment from "moment";
import DatePicker from "react-datepicker";
import {decode} from 'html-entities'
import { Uploader } from "rsuite";


const EditAthlet = () => {

	

	let navigate = useNavigate();

	const [res,setRes] = useState([]);
	const username = localStorage.getItem('username')

	const [fname,setFname] = useState('');
	const [mname,setMname] = useState('');
    const [lname,setLame] = useState('');
    const [dob,setDob] = useState('');
    const [gender,setGender] = useState('');
    const [grade,setGrade] = useState('');
    const [year_8th,setYear_8th] = useState('');
    const [year_9th,setYear_9th] = useState('');
    const [schoollast,setSchoollast] = useState(0);
	// const [csiet,setCsiet] = useState('');
	const [gisa,setGisa] = useState('');
	const [school_gisa,setSchool_gisa] = useState('');
	const [datetransfered,setDatetransfered] = useState('');
	const [unit,setUnit] = useState('');
	const [status,setStatus] = useState('');
	const [aes, setAes] = useState('')

	const [inactive, setInactive] = useState('');
	const [deleted, setDeleted] = useState('');

	const [schresult,setSchresult] = useState([]);
	const [schoolName,setSchoolName] = useState("");
	const [programresult,setProgramresult] = useState([]);

	const [fnameerror,setFnameerror] = useState(false);
	const [lnameerror,setLnameerror] = useState(false);
	const [doberror,setDoberror] = useState(false);
	const [gendererror,setGendererror] = useState(false);
	const [gradeerror,setGradeerror] = useState(false);
	const [year_8therror,setYear_8therror] = useState(false);
	const [year_9therror,setYear_9therror] = useState(false);
	const [school_gisaerror,setSchool_gisaerror] = useState(false);
	const [datetransferederror,setDatetransferederror] = useState(false);
	const [uniterror,setUniterror] = useState(false);
	
	const [agee, setAgee] = useState('');
	const [public_school_name,setPublic_school_name] = useState('');
	const [public_city,setPublic_city] = useState('');
	const [public_state,setPublic_state] = useState('');
	const [public_country,setPublic_country] = useState('');

	const [private_school_name,setPrivate_school_name] = useState('');
	const [private_city,setPrivate_city] = useState('');
	const [private_state,setPrivate_state] = useState('');
	const [private_country,setPrivate_country] = useState('');

	const [home_school,setHome_school] = useState('');
	const [home_city,setHome_city] = useState('');
	const [home_state,setHome_state] = useState('');
	const [home_country,setHome_country] = useState('');

	const [sevp_school,setSevp_school] = useState('');
	const [sevp_city,setSevp_city] = useState('');
	const [sevp_state,setSevp_state] = useState('');
	const [sevp_country,setSevp_country] = useState('');

	const [aesname,setAesName] = useState('');
	const [aescity,setAesCity] = useState('');
	const [aesstate,setAesState] = useState('');
	const [aescountry,setAesCountry] = useState('');

	const [status1,setStatus1] = useState(0);
	const [status2,setStatus2] = useState('');
	const [notes,setNotes] = useState('');
	const [international_school,setInternational_school] = useState('');
	const [openInterSchoolForm, setOpenInterSchoolForm] = useState(true)
	const [openInterSchoolForm1, setOpenInterSchoolForm1] = useState(false)
	const [interformnull, setInterFormNull] = useState(false)
	const [aesPre, setAesPre] = useState('');


	const [provideDate, setProvideDate] = useState();

	const [open, setOpen] = useState(false);
	const [ type, setType ] = useState('')
	const [openXFR, setOpenXFR] = useState(true);
	const [openXFR1, setOpenXFR1] = useState(false);
	const [xfrtype, setXfrType] = useState('');

	const [aesCompleted, setAesCompleted] = useState('');
	const [aesCompletedError, setAesCompletedError] = useState(false);
	const [is8thGrade, setIs8thGrade] = useState('');
	const [is8thGradeError, setIs8thGradeError] = useState(false);
	const [fileUrl8th, setFileUrl8th] = useState('');
	const [fileSelect8th, setFileSelect8th] = useState('');
	const [isTransferStudent, setIsTransferStudent] = useState('');
	const [isTransferStudentError, setIsTransferStudentError] = useState(false);

	// Add these radio button state variables for proper selection handling
	const [aesCompletedYes, setAesCompletedYes] = useState(false);
	const [aesCompletedNo, setAesCompletedNo] = useState(false);
	const [is8thGradeYes, setIs8thGradeYes] = useState(false);
	const [is8thGradeNo, setIs8thGradeNo] = useState(false);
	const [isTransferStudentYes, setIsTransferStudentYes] = useState(false);
	const [isTransferStudentNo, setIsTransferStudentNo] = useState(false);

	////
	// Function to calculate age
	const calculateAge = (birthDate) => {
		const today = new Date();
		const birth = new Date(birthDate);
		let age = today.getFullYear() - birth.getFullYear();
		const monthDifference = today.getMonth() - birth.getMonth();
	
		if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birth.getDate())) {
		  age--;
		}
	
		return age;
	  };
	
	  useEffect(() => {
		if (dob) {
		  const calculatedAge = calculateAge(dob);
		  setAgee(calculatedAge);
		}
	  }, [dob]);

	///

	const AEStrue = () => {
		setAes("YES")
		setOpenXFR(true);
		setOpenXFR1(true)
		setYesSelectaes1(false)
		setYesSelectaes2(true)
		setNoSelectaes2(false)
		setNoSelectaes1(true)
	}

	const AESfalse = () => {
		setAes("NO")
		setOpenXFR(false);
		setOpenXFR1(false);
		setYesSelectaes1(true)
		setYesSelectaes2(false)
		setNoSelectaes2(true)
		setNoSelectaes1(false)
	}


	const [inter_true, setInter_true] = useState(false)
	const [inter_true1, setInter_true1] = useState(true)
	const [inter_false, setInter_false] = useState(false)
	const [inter_false1, setInter_false1] = useState(true)

	const inter_yes = () => {
		setInternational_school("YES")
		setInter_true(true)
		setInter_true1(false)
		setInter_false(false)
		setInter_false1(true)
		setOpenInterSchoolForm(true);	
		setOpenInterSchoolForm1(true)
	}

	const inter_no = () => {
		setInternational_school("NO")
		setInter_true(false)
		setInter_false(true)
		setInter_false1(false)
		setInter_true1(true)
		setOpenInterSchoolForm(false);
		setOpenInterSchoolForm1(false)
	}

	const inter_yes_null=()=>{
		setInterFormNull(true)
	}

	const inter_no_null=()=>{
		setInterFormNull(false)
	}

    const [csiet,setCsiet] = useState('');


	const { sid,aid } = useParams();

	const [yesSelectXFR1, setYesSelectXFR1 ] = useState(true)
	const [yesSelectXFR2, setYesSelectXFR2 ] = useState(false)


	const [noSelectXFR1, setNoSelectXFR1 ] = useState(true)
	const [noSelectXFR2, setNoSelectXFR2 ] = useState(false)



	const [yesSelectaes1, setYesSelectaes1 ] = useState(true)
	const [yesSelectaes2, setYesSelectaes2 ] = useState(false)
	const [noSelectaes1, setNoSelectaes1 ] = useState(true)
	const [noSelectaes2, setNoSelectaes2 ] = useState(false)
	


	const openSet = () => {
		// res.aes_status = 'YES'
		setOpen(true);
		setXfrType("YES")
		setNoSelectXFR1(false)
		setNoSelectXFR2(true)
		setYesSelectXFR1(true)
		setYesSelectXFR2(false)
		console.log(xfrtype)
		if(status1 === ''){
			setStatus1('')
		}
	}
	
	const openType = () => {
		// res.aes_status = 'YES'
		setXfrType("NO")
		setOpen(false);
		setNoSelectXFR1(true)
		setNoSelectXFR2(false)
		setYesSelectXFR2(true)
		setYesSelectXFR1(false)
		setStatus1('');
		console.log(xfrtype)

	}

	useEffect( ()=>{



		schools();
		programs();
		EditListing();
		SchoolView();


		// console.log("aaaa", res.aes_status)


	},[])

	useEffect(() => {



		let dateDropdown = document.getElementById('date-dropdown');

		let currentYear = new Date().getFullYear();
		let earliestYear = 2010;

		while (currentYear >= earliestYear) {
		let dateOption = document.createElement('option');
		dateOption.text = currentYear;
		dateOption.value = currentYear;
		dateDropdown.add(dateOption);
		currentYear -= 1;
		}

	},[]);

	useEffect(() => {

		if(grade >= 9)
			{

			

				let dateDropdown = document.getElementById('date-dropdown2');

				let currentYear = new Date().getFullYear();
				let earliestYear = 2010;

				while (currentYear >= earliestYear) {
				let dateOption = document.createElement('option');
				dateOption.text = currentYear;
				dateOption.value = currentYear;
				dateDropdown.add(dateOption);
				// console.log("DAte option", dateOption);
				currentYear -= 1;
				}
			}

			if(res.aes_status === 'YES'){
				setOpen(true)
			}else{
				setOpen(false)
			}
		
	},[grade]);


useEffect( ()=>{
    var keys = Object.keys(res);
    var len = keys.length

    if(len>0)
    {
        setFname(res.first_name)
        setMname(res.middle_name)
        setLame(res.last_name)
        setDob(res.dob)
        setGender(res.gender)
        setGrade(res.current_grade)
        setYear_8th(res.year_8)
        setYear_9th(res.year_9)
        setCsiet(res.csiet_foreign_exchange)
        setGisa(res.gisa_foreign_exchange)
        
        setDatetransfered(res.date_transfered)
        setUnit(res.units_passed)
        setStatus(res.status)
        setStatus1(res.status1)
        setAgee(res.age)
        setPublic_school_name(res.public_school_name)
        setPublic_city(res.public_city)
        setPublic_state(res.public_state)
        setPublic_country(res.public_country)
        setPrivate_school_name(res.private_school_name)
        setPrivate_city(res.private_city)
        setPrivate_state(res.private_state)
        setPrivate_country(res.private_country)
        setXfrType(res.aes_status)
        setInternational_school(res.international_school)
        setHome_school(res.home_school)
        setHome_city(res.home_city)
        setHome_state(res.home_state)
        setHome_country(res.home_country)
        setSevp_school(res.sevp_school)
        setSevp_city(res.sevp_city)
        setSevp_state(res.sevp_state)
        setSevp_country(res.sevp_country)
        setSchoollast(res.last_schoolId)
        setAesPre(res.aesdrop)
        setNotes(res.notes)
        setAes(res.aes)
        setFileUp(res.fileURL)
        setAesName(res.aesname)
        setAesCity(res.aescity)
        setAesState(res.aesstate)
        setAesCountry(res.aescountry)

        // Fix the field mapping for new questions
        setAesCompleted(res.aes_completed || '');
        setIs8thGrade(res.student_8th || '');
        setFileUrl8th(res.fileurl_8th || '');
        
        // FIXED: Use res.transfer_student instead of res.transfer_student
        setIsTransferStudent(res.transfer_student || '');
        
        // Set radio button states based on data
        setAesCompletedYes(res.aes_completed === 'YES');
        setAesCompletedNo(res.aes_completed === 'NO');
        setIs8thGradeYes(res.student_8th === 'YES');
        setIs8thGradeNo(res.student_8th === 'NO');
        
        // FIXED: Set transfer student radio states correctly
        setIsTransferStudentYes(res.transfer_student === 'YES');
        setIsTransferStudentNo(res.transfer_student === 'NO');

        if(res.fileurl_8th){
            setFileSelect8th((res.fileurl_8th).split("/")[3])
        }

        if(res.fileURL){
            setFileSelect((res.fileURL).split("/")[3])
        }
    }

    console.log("aesStatus", res.aes_status)
    if(res.aes_status === "NO"){
        setOpen(true)
    }else{
        setOpen(false)
    }

},[res])

	const RoutToList = () =>{
        navigate("/school_list/athlet_list/"+sid)
    }

	


	const schools = () => {
		let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: schoolsApiurl,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            // setSchresult(response.data.data.items);
			setSchresult(response.data.data.sort((a, b) => a.name.localeCompare(b.name)))
            //console.log('schoolname',response.data.data)
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
	}

	const programs = () => {
		let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: foreignexchangelists+"/dropdown",

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setProgramresult(response.data.data.items);
           	//console.log('programs',response.data.data)
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
	}


	const [loadingBtn, setLoadingBtn] = useState(false)
	const [homeSchoolError, setHomeSchoolError] = useState(false)
	const [homeCityError, setHomeCityError] = useState(false)
	const [homeStateError, setHomeStateError] = useState(false)
	const [homeCountryError, setHomeCountryError] = useState(false)

	const [sevpSchoolError,setSevpSchoolError] = useState(false);
	const [sevpCityError,setSevpCityError] = useState(false);
	const [sevpStateError,setSevpStateError] = useState(false);
	const [sevpCountryError,setSevpCountryError] = useState(false);

	const [aesNameError,setAesNameError] = useState(false);
	const [aesCityError,setAesCityError] = useState(false);
	const [aesStateError,setAesStateError] = useState(false);
	const [aesCountryError,setAesCountryError] = useState(false);


	const [errorStatus1,setErrorStatus1] = useState(false);


	const onEditELigibility = () => {

		setLoadingBtn(true)


		let error = 0;

		if(fname === '')
		{
			setFnameerror(true)
			error =1;
		}
		else
		{
			setFnameerror(false)
		}
		if(lname === '')
		{
			setLnameerror(true)
			error =1;
		}
		else
		{
			setLnameerror(false)
		}
		if(dob === '')
		{
			setDoberror(true)
			error =1;
		}
		else
		{
			setDoberror(false)
		}
		if(gender === '')
		{
			setGendererror(true)
			error =1;
		}
		else
		{
			setGendererror(false)
		}
		if(grade === '')
		{
			setGradeerror(true)
			error =1;
		}
		else
		{
			setGradeerror(false)
		}
		if(year_8th === '')
		{
			setYear_8therror(true)
			error =1;
		}
		else
		{
			setYear_8therror(false)
		}
		if(year_9th === '')
		{
			setYear_9therror(true)
			error =1;
		}
		else
		{
			setYear_9therror(false)
		}

		// if(school_gisa === '')
		// {
		// 	setSchool_gisaerror(true)
		// 	error =1;
		// }
		// else
		// {
		// 	setSchool_gisaerror(false)
		// }

		// if(datetransfered === '')
		// {
		// 	setDatetransferederror(true)
		// 	error =1;
		// }
		// else
		// {
		// 	setDatetransferederror(false)
		// }

		// if(datetransfered === '')
		// {
		// 	setDatetransferederror(true)
		// 	error =1;
		// }
		// else
		// {
		// 	setDatetransferederror(false)
		// }
		if(unit === '')
		{
			setUniterror(true)
			error =1;
		}
		else
		{
			setUniterror(false)
		}

		let years9='';

		if(grade >= 9)
		{
			years9 = year_9th;

		}else{
			years9 = "NA";
		}



		if(xfrtype === "YES"){

		if(status1 === '0' || status1 === '' || status1 === "" || status === null)
		{
			setErrorStatus1(true);
			error =1;
		}
		else{
			setErrorStatus1(false);
			error = 0; 
		}

		if(aes === 'YES' && aesCompleted === '') {
			setAesCompletedError(true);
			error = 1;
		} else {
			setAesCompletedError(false);
		}

		// Add validation for 8th grade student
		if(is8thGrade === '') {
			setIs8thGradeError(true);
			error = 1;
		} else {
			setIs8thGradeError(false);
		}

		// Add validation for 8th grade file upload (required if 8th grade student)
		if(is8thGrade === 'YES' && !fileUrl8th) {
			alert("8th grade students are required to upload a document");
			error = 1;
		}

		// Add validation for transfer student
		if(isTransferStudent === '') {
			setIsTransferStudentError(true);
			error = 1;
		} else {
			setIsTransferStudentError(false);
		}
	}

		if(status1 === 'HOME SCHOOL')
		{
			if(home_school ===null || home_school === '')
			{
				setHomeSchoolError(true)
				error =1;
			}else{
				setHomeSchoolError(false)
			}
			if(home_city ===null || home_city ==='')
			{
				setHomeCityError(true)
				error =1;
			}else{
				setHomeCityError(false)
				error = 0;
			}
			if(home_state ===null || home_state ==='')
			{
				setHomeStateError(true)
				error =1;
			}else{
				setHomeStateError(false)
				error = 0;
			}
			if(home_country ===null || home_country === '')
			{
				setHomeCountryError(true)
				error =1;
			}else{
				setHomeCountryError(false)
				error = 0;
			}

		}

		if(status1 === 'NON-MEMBER PRIVATE SCHOOL')
		{
			if(private_school_name ===null || private_school_name ==='')
			{
				setHomeSchoolError(true)
				error =1;
			}else{
				setHomeSchoolError(false)
			}
			if(private_city ===null || private_city === '')
			{
				setHomeCityError(true)
				error =1;
			}else{
				setHomeCityError(false)
				error = 0;
			}
			if(private_state ===null || private_state === '')
			{
				setHomeStateError(true)
				error =1;
			}else{
				setHomeStateError(false)
				error = 0;
			}
			if(private_country === null || private_country === '')
			{
				setHomeCountryError(true)
				error =1;
			}else{
				setHomeCountryError(false)
				error = 0;
			}

		}


		if(status1 === 'PUBLIC SCHOOL')
		{
			if(public_school_name ===null || public_school_name ==='')
			{
				console.log("aaasamkasnas", public_school_name)
				setHomeSchoolError(true)
				error =1;
			}else{
				setHomeSchoolError(false)
			}
			if(public_city ===null || public_city ==='')
			{
				setHomeCityError(true)
				error =1;
			}else{
				setHomeCityError(false)
				error = 0;
			}
			if(public_state ===null || public_state ==='')
			{
				setHomeStateError(true)
				error =1;
			}else{
				setHomeStateError(false)
				error = 0;
			}
			if(public_country ===null || public_country ==='')
			{
				setHomeCountryError(true)
				error =1;
			}else{
				setHomeCountryError(false)
				error = 0;
			}

		}

		console.log("school last", schoollast)
		if(status1 === 'GISA/GIAA MEMBER SCHOOL'){
			if(schoollast === ''){
				setSchool_gisaerror(true)
				error = 1
			}else{
				setSchool_gisaerror(false)
				error =0
			}
		}




		if(status1 === 'SEVP SCHOOL')
		{
			if(sevp_school ===null ||sevp_school ==='')
			{
				setSevpSchoolError(true)
				error =1;
			}else{
				setSevpSchoolError(false)
			}
			if(sevp_city ==='')
			{
				setSevpCityError(true)
				error =1;
			}else{
				setSevpCityError(false)
				error = 0;
			}
			if(sevp_state ==='')
			{
				setSevpStateError(true)
				error =1;
			}else{
				setSevpStateError(false)
				error = 0;
			}
			if(sevp_country ==='')
			{
				setSevpCountryError(true)
				error =1;
			}else{
				setSevpCountryError(false)
				error = 0;
			}

		}







		if(status1 === 'VIA CSIET-APPROVED EXCHANGE PROGRAM'){
			if(csiet === ''){
				setSchool_gisaerror(true)
				error = 1
			}else{
				setSchool_gisaerror(false)
				error =0
			}
		}

		if(error === 0){
			let token = "Bearer "+localStorage.getItem('token');
		


        
        const data = {
            school_id:sid,
            first_name :fname,
			middle_name:mname,
            last_name:lname,
            dob:moment(dob).format('MM-DD-YYYY'),
			age:agee,
            gender:gender,
            current_grade:grade,
            year_8 :year_8th,
            year_9 :years9,
			
			units_passed:unit,
			date_transfered:moment(datetransfered).format('MM-DD-YYYY'),
			last_school:status1 === "GISA/GIAA MEMBER SCHOOL"?schoollast:0,
			// unlisted_school:unlistschoolname,
			// unlisted_school_city:unlistschoolcity,
			// unlisted_school_state:unlistschoolstate,
			public_school_name: public_school_name,
			public_city:public_city,
			public_state: public_state,
			public_country:public_country,

			private_school_name: private_school_name,
			private_city: private_city,
			private_state: private_state,
			private_country: private_country,
			
			home_school:home_school,
			home_city:home_city,
			home_state:home_state,
			home_country:home_country,

			sevp_school:sevp_school,
			sevp_city:sevp_city,
			sevp_state:sevp_state,
			sevp_country:sevp_country,

			aesname:aesname,
			aescity:aescity,
			aesstate:aesstate,
			aescountry:aescountry,

			csiet_foreign_exchange:status1 === "VIA CSIET-APPROVED EXCHANGE PROGRAM"?csiet:null,
			gisa_foreign_exchange:gisa,
			status:status || 'ACTIVE',
			status1: status1,
			inactive_reason: inactive,
			deleted_reason: deleted,
			aes_status: xfrtype,
			notes:notes,
			aes:aes || 'NO',
			aesdrop:status1 === "AES SCHOOL"?"YES":"NO",
			international_school:international_school,
			fileURL:fileUp,
			aes_completed: aesCompleted,
			student_8th: is8thGrade,
			fileurl_8th: fileUrl8th,
			transfer_student: isTransferStudent,
        }

		//console.log('dtas',data)
        
        const instance = axios.create({

            baseURL: eligibility+sid+'/'+aid,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.put('',data).then((response) =>{
            
			setLoadingBtn(false)
            
            navigate("/school_list/athlet_list/"+sid)

				}).catch((error) =>{
					
					console.log('error',error.message)
					setProvideDate(error.response.data.error[0].date_transfered)
					
				});
			}
	}



	



	

	const EditListing = () => {
		let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: eligibility+sid+'/'+aid,

            timeout: 1000000,

            headers: {'authorization': token}

            });
            
            instance.get('').then((response) =>{
            
            setRes(response.data.data);
			setAgee(response.data.data.age)
            console.log('respossss',response.data.data)
        
            
            }).catch((error) =>{
            
            console.log('error',error.message)
            

            });
	}

	const SchoolView = () => {
		let token = "Bearer "+localStorage.getItem('token');
		
		const instance = axios.create({
	
			baseURL: schoolsurl+'/'+sid,
	
			timeout: 1000000,
	
			headers: {'authorization': token}
	
		  });
		  
		  instance.get('').then((response) =>{
			setSchoolName(response?.data?.data);
		   
		  }).catch((error) =>{ 
			
			console.log('error',error.message)
	
			//localStorage.removeItem('token')
			//navigate("/")
			
	
		  });
	}

	let selected = '';


	const [checkCofirmbtn, setCheckConfirmBtn] = useState(false);

	const checkCofirm = event => {
	  if (event.target.checked) {
		setCheckConfirmBtn(false)
	  } else {
		setCheckConfirmBtn(true)
	  }
	  setCheckConfirmBtn(current => !current);
	};


	const ageError =()=>{
		alert("Your age above 20")
	} 



	
	const age_calc = (e) => {
		
		// console.log("year_born", e.target.value);

		setDob(e.target.value)

		var birthDate = new Date(e.target.value);
		var currentDate = new Date();
		var age = currentDate.getFullYear() - birthDate.getFullYear();

		console.log("currentDate", currentDate.getFullYear(),"birthDate" ,birthDate.getFullYear())

		setAgee(age);
		if(currentDate.getFullYear() <= birthDate.getFullYear()) {
			setAgee(0);
		}

		if(e.target.value === null){
			console.log("yearrr", e.target.value);
			setAgee('');
			return false 
		}

		var n = currentDate.getMonth() - birthDate.getMonth();
		if (n < 0 || (n === 0 && currentDate.getDate() < birthDate.getDate())) 
		{
			if(birthDate.getFullYear() > currentDate.getFullYear()){
				console.log("testtt");

				age--;
			}
			else{
				age--;
			}
			setAgee(age);
			console.log("Real age is" , age);
		}
		
		return age;



	}





	const [fileUp, setFileUp] = useState('');
	const [fileSelect, setFileSelect] = useState('');

	const changeHandler8th = (event) => {
		setFileSelect8th(event.name);

		let token = "Bearer " + localStorage.getItem('token');
		const data = new FormData();
		data.append('file', event);

		const instance = axios.create({
			baseURL: FileUploadAthletURL,
			timeout: 1000000,
			headers: {'authorization': token, "Content-Type": "multipart/form-data"},
		});

		instance.post('', data).then((response) => {
			console.log("8th grade file response", response.data);
			setFileUrl8th(response.data.Location);
		}).catch((error) => {     
			console.log('error', error.message);  
		});
	};


	const  changeHandler=(event)=>{

		setFileSelect(event.name)

		let token = "Bearer "+localStorage.getItem('token');

        const data = new FormData();

        data.append('file', event)

        const instance = axios.create({
            baseURL: FileUploadAthletURL,
            timeout: 1000000,
            headers: {'authorization': token, "Content-Type":  "multipart/form-data"},
        });


        instance.post('', data).then((response) =>{

			console.log("respooonse", response.data)
			setFileUp(response.data.Location)

        }).catch((error) =>{     
            console.log('error',error.message)  
        });

	}

	const handleAesCompletedYes = () => {
    setAesCompleted('YES');
    setAesCompletedYes(true);
    setAesCompletedNo(false);
    setLoadingBtn(false);
};

const handleAesCompletedNo = () => {
    setAesCompleted('NO');
    setAesCompletedYes(false);
    setAesCompletedNo(true);
    setLoadingBtn(false);
};

const handle8thGradeYes = () => {
    setIs8thGrade('YES');
    setIs8thGradeYes(true);
    setIs8thGradeNo(false);
    setLoadingBtn(false);
};

const handle8thGradeNo = () => {
    setIs8thGrade('NO');
    setIs8thGradeYes(false);
    setIs8thGradeNo(true);
    setLoadingBtn(false);
};

const handleTransferStudentYes = () => {
    setIsTransferStudent('YES');
    setIsTransferStudentYes(true);
    setIsTransferStudentNo(false);
    setLoadingBtn(false);
};

const handleTransferStudentNo = () => {
    setIsTransferStudent('NO');
    setIsTransferStudentYes(false);
    setIsTransferStudentNo(true);
    setLoadingBtn(false);
};
    

    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                   
                <div className="page-title-wrpr">
                    <div className="page-title-left-column"> 
                        <h2 className="page-title">Edit Eligibility</h2>
                    </div>
                    <div className="page-rightside-action-column">               
                    </div>  
                </div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        <li className="breadcrumb-item"><Link to={"/school_list/athlet_list/"+sid}>Athletic Eligibility</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Edit Eligibility</li>
                    </ol>
                </nav>

                <div className="form-wrpr">
					<div className="card formcard medium">
						<div className="card-body">
							
							<div className="form-group">
								<div className="row">
									<div className="col-md-6">
										<label >First Name:<span style={{color: "red"}}>*</span></label>
										<input type="text" className="form-control justshow bg-dark" defaultValue={res.first_name} onChange={e => {setFname(e.target.value);setLoadingBtn(false)}}  placeholder="Enter First Name" />
										{
											fnameerror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter first name</div>
											:null
                            			}
									</div>
									<div className="col-md-6">
										<label >Middle Name: </label>
										<input type="text" className="form-control justshow bg-dark" defaultValue={res.middle_name} onChange={e => {setMname(e.target.value);setLoadingBtn(false)}}  placeholder="Enter Middle Name" />
										{/* {
											lnameerror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter last name</div>
											:null
                            			} */}
									</div>
									
								</div>
								
							</div>

							<div className="form-group">
								<div className="row">
									<div className="col-md-6">
										<label >Last Name:<span style={{color: "red"}}>*</span></label>
										<input type="text" className="form-control justshow bg-dark" defaultValue={res.last_name} onChange={e => {setLame(e.target.value);setLoadingBtn(false)}}  placeholder="Enter Last Name" />
										{
											lnameerror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter last name</div>
											:null
                            			}
									</div>

									<div className="col-md-6">
										<label >Gender<span style={{color: "red"}}>*</span></label>
										
										<select className="form-control justshow bg-dark " onChange={e => {setGender(e.target.value);setLoadingBtn(false)}}>
											<option value="">Select Gender</option>
											<option value="MALE" selected={res.gender === 'MALE'}>MALE</option>
											<option value="FEMALE" selected={res.gender === 'FEMALE'}>FEMALE</option>
										</select>
										{
											gendererror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter gender</div>
											:null
                            			}
									</div>
									
									
								</div>
								
							</div>
							
							
							<div className="form-group">
								<div className="row">
									
									<div className="col-md-6">
										<label >Date of Birth<span style={{color: "red"}}>*</span></label>	
										{/* <input type="date" className="form-control justshow bg-dark" defaultValue={res.dob}
										 onChange={e => {setDob(e.target.value)}}  placeholder="Enter Date of Birth" /> */}
					
										<input
											className="form-control justshow bg-dark"
											type="date"
											// selected={moment(res.dob).format('MM-DD-YYYY')}
											onChange={(date) => age_calc(date)}
											defaultValue={res.dob}
											// isClearable
											// onKeyDown={(e) => {
											// 	e.preventDefault();
											// }}
											// maxDate={moment(Date())}
											filterDate = {(date) => {
												return moment() > date;
											  }}
											placeholderText="Enter Date Of Birth (MM-DD-YY)"
											showMonthDropdown={true}
											showYearDropdown={true}
											scrollableYearDropdown={false}
										/>

										{
											doberror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter date of birth</div>
											:null
                            			}
									</div>

									<div className="col-md-6">
										<label >Age:<span style={{color: "red"}}>*</span></label>
									
										<input type="text" className="form-control justshow bg-dark" disabled  value={agee?agee:res.age} onChange={e => {setAgee(e.target.value);setLoadingBtn(false)}}  placeholder="Age" />
										{/* {
											lnameerror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter age</div>
											:null
                            			} */}
									</div>
									

								</div>
								
							</div>
							
							
							<div className="form-group">
								<div className="row">
									
									<div className="col-md-6">
										<label >Grade Level Current School Year<span style={{color: "red"}}>*</span></label>
										<select className="form-control justshow bg-dark" onChange={e => {setGrade(e.target.value);setLoadingBtn(false)}}>
											<option>Select Grade Level</option>
											<option value="8" selected={res.current_grade === 8}>8</option>
											<option value="9" selected={res.current_grade === 9}>9</option>
											<option value="10" selected={res.current_grade === 10}>10</option>
											<option value="11" selected={res.current_grade === 11}>11</option>
											<option value="12" selected={res.current_grade === 12}>12</option>
										</select>
										{
											gradeerror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter grade</div>
											:null
                            			}
									</div>
									<div className="col-md-6">
										<label >Year Entered 8th Grade<span style={{color: "red"}}>*</span></label>
										{/* <input type="text" className="form-control justshow bg-dark" defaultValue={res.year_8} onChange={e => {setYear_8th(e.target.value)}}  placeholder="Enter Year Entered in 8th Grade" /> */}
										<select
											placeholder="Enter Year Entered in 8th Grade"
											id="date-dropdown"
											defaultValue={year_8th}
											className="form-control justshow bg-dark"	
											onChange={e => {setYear_8th(e.target.value);setLoadingBtn(false)}}
										>
											{/* <option selected={year_8th}>{year_8th}</option> */}
											<option defaultValue={year_8th} selected={res.year_8 === year_8th}>{year_8th}</option>
											{/* <option>{year_8th}</option> */}
										</select>
										{
											year_8therror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter 8th grade</div>
											:null
                            			}
									</div>
								</div>
								
							</div>
							
							
							<div className="form-group">
								<div className="row">
									
									<div className="col-md-6">
										<label >Year Entered 9th Grade <span style={{color: "red"}}>*</span></label>
										

										{
											grade >= 9?
											(

												<select
													placeholder="Enter Year Entered in 9th Grade"
													id="date-dropdown2"
													defaultValue={year_9th}
													className="form-control justshow bg-dark"
													onChange={e => {setYear_9th(e.target.value);setLoadingBtn(false)}}
												>
													{/* <option value="0">Select Year</option> */}
													<option defaultValue={year_9th} selected={res.year_9 === year_8th}>{year_9th}</option>
												</select>

											):
											(<input type="text" className="form-control justshow bg-dark" defaultValue="NA"  placeholder="Enter Year Entered in 9th Grade"/>)
										}
										

										{/* {
										 	year_9therror
										 	? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter 9th grade</div>
										 	:null
                            			 } */}
									</div>

									<div className="col-md-6">
										<label >Date transfered to</label>
										<input type="date" className="form-control justshow bg-dark" defaultValue={res.date_transfered} onChange={e => {setDatetransfered(e.target.value);setLoadingBtn(false)}} />
										{/* {
											datetransferederror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter date</div>
											:null
											
                            			}	 */}
										{
											provideDate? 
											<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Provide valid date.</div>
											:null
                            			}
									</div>
									
										
									{/* <div className="col-md-6">
										<label >GISA Schools<span style={{color: "red"}}>*</span> </label>
										<select className="form-control justshow bg-dark" onChange={e => {setSchool_gisa(e.target.value)}}>
											<option>Select GISA School</option>
											{ schresult?.map((item,index)=>(
												<option key={index} value={item.id} selected={res.gisa_school === item.id}>{item.name}</option>
											)
											
											) }
										</select>
										{
											school_gisaerror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter gisa school</div>
											:null
                            			}
										
									</div> */}
										
								</div>
								
							</div>

							<div className="form-group">
								<div className="row">
									<div className="col-md-6">
										<label >Number of Units Passed Last Grading Period<span style={{color: "red"}}>*</span></label>
										<select className="form-control justshow bg-dark" onChange={e => {setUnit(e.target.value);setLoadingBtn(false)}}>
											<option>Select Unit</option>
											<option value="5" selected={res.units_passed === '5'}>5</option>
											<option value="6" selected={res.units_passed === '6'}>6</option>
											<option value="7" selected={res.units_passed === '7'}>7</option>
											<option value="8" selected={res.units_passed === '8'}>8</option>
											<option value="9" selected={res.units_passed === '9'}>9</option>
											<option value="10" selected={res.units_passed === '10'}>10</option>		
										</select>	
										{
											uniterror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter unit</div>
											:null
                            			}
									</div>

									{/* <div className="col-md-6">
										<label >Date transfered to {schoolName.name} <span style={{color: "red"}}>*</span></label>
										<input type="date" className="form-control justshow bg-dark" defaultValue={res.date_transfered} onChange={e => {setDatetransfered(e.target.value)}} />
										{
											datetransferederror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter date</div>
											:null
                            			}	
									</div> */}

								</div>
							</div>

							<div className="mb-5"></div> 

							<div className="form-group">
                                         
                                <div className="row">

                                    <div className="col-md-6">
                                            
									<label>Is this an AES (Homeschool) Student?<span style={{color: "red"}}>*</span></label>
                                            
                                            <div class="radio-btn-type">    

											{res.aes === "YES"?
                                                <Fragment>
                                                <label>
                                                    
                                                    <input type="radio" 
                                                        onClick={AEStrue}  
														onChange={e => {setAes(e.target.value);setLoadingBtn(false)}}
                                                        name="type"
														value="YES"
                                                        checked
														/><span className="new-previous-label">Yes</span>
                                                
                                                </label>

												{noSelectaes1?<div>
                                                
                                                <label>
                                                    
                                                    <input type="radio" 
                                                        onClick={AESfalse} 
														onChange={e => {setAes(e.target.value);setLoadingBtn(false)}}
                                                        name="type" 
														value="NO"
														/><span className="new-previous-label">No</span>
                                                
                                                </label>
												</div>:null}
												{noSelectaes2?<div>
                                                
                                                <label>
                                                    
                                                    <input type="radio" 
														checked
                                                        onClick={AESfalse} 
														onChange={e => {setAes(e.target.value);setLoadingBtn(false)}}
                                                        name="type" 
														value="NO"
														/><span className="new-previous-label">No</span>
                                                
                                                </label>
												</div>:null}


												</Fragment>:null}







												{res.aes === "NO"?
                                                <Fragment>
                                                <label>
                                                    
													<input type="radio" 
														checked
                                                        onClick={AESfalse} 
														onChange={e => {setAes(e.target.value);setLoadingBtn(false)}}
                                                        name="type" 
														value="NO"
														/><span className="new-previous-label">No</span>
                                                
                                                
                                                </label>

												{yesSelectaes1?<div>
                                                
                                                <label>
                                                    
												<input type="radio" 
                                                        onClick={AEStrue}
														onChange={e => {setAes(e.target.value);setLoadingBtn(false)}}  
                                                        name="type"
														value="YES"
														/><span className="new-previous-label">Yes</span>

                                                </label>
												</div>:null}
												{yesSelectaes2?<div>
                                                
                                                <label>
                                                    
												<input type="radio" 
                                                        onClick={AEStrue}
														onChange={e => {setAes(e.target.value);setLoadingBtn(false)}}  
                                                        name="type"
														value="YES"
                                                        checked
														/><span className="new-previous-label">Yes</span>

                                                
                                                </label>
												</div>:null}


												</Fragment>:null}
                                            
                                            </div>

                                    </div>

                                </div>

                            </div>
	                        <div className="mb-5"></div> 
							{(aes === 'YES' || res.aes === 'YES') && (
								<div className="form-group">
									<div className="row">
										<div className="col-md-6">
											<label>Has this AES student application been completed and approved by the GIAA Office?<span style={{color: "red"}}>*</span></label>
											<div className="radio-btn-type">    
												<label>
													<input 
														type="radio" 
														name="aesCompleted"
														value="YES"
														checked={aesCompletedYes}
														onClick={handleAesCompletedYes}
													/>
													<span className="new-previous-label">Yes</span>
												</label>
												
												<label>
													<input 
														type="radio" 
														name="aesCompleted"
														value="NO"
														checked={aesCompletedNo}
														onClick={handleAesCompletedNo}
													/>
													<span className="new-previous-label">No</span>
												</label>
											</div>
											{aesCompletedError && (
												<div className="nerrors" style={{color:"red", fontSize: "12.8px"}}>
													Please select if AES application has been completed
												</div>
											)}
										</div>
									</div>
								</div>
							)}

							{/*	{aesCompleted === 'YES' && (
    <div>
        <div className="mb-5"></div> 
        <label style={{fontSize: '14px'}}>
            <a href="https://form.jotform.com/242213782125147">CLICK HERE</a> for AES Student Application Form
        </label>
    </div>
)} */}


							







							<div className="mb-5"></div> 

							<div className="form-group">
										
								<div className="row">

									<div className="col-md-6">
											
									<label>Is this an International Student?<span style={{color: "red"}}>*</span></label>
											
											<div class="radio-btn-type">    

											{res.international_school === "YES"?
												<Fragment>
												<label>
													
													<input type="radio" 
														onChange={e => {setInternational_school(e.target.value);setLoadingBtn(false)}}
														name="type1"
														onClick={inter_yes}
														value="YES"
														checked
														/><span className="new-previous-label">Yes</span>
												
												</label>

												{inter_false1?<div>
												
												<label>
													
													<input type="radio"
														onClick={inter_no} 
														onChange={e => {setInternational_school(e.target.value);setLoadingBtn(false)}}
														name="type1" 
														value="NO"
														/><span className="new-previous-label">No</span>
												
												</label>
												</div>:null}
												{inter_false?<div>
												
												<label>
													
													<input type="radio" 
														checked
														onClick={inter_no}
														onChange={e => {setInternational_school(e.target.value);setLoadingBtn(false)}}
														name="type1" 
														value="NO"
														/><span className="new-previous-label">No</span>
												
												</label>
												</div>:null}


												</Fragment>:null}







												{res.international_school === "NO"?
												<Fragment>
												<label>
													
													<input type="radio" 
														checked
														onClick={inter_no}
														onChange={e => {setInternational_school(e.target.value);setLoadingBtn(false)}}
														name="type1" 
														value="NO"
														/><span className="new-previous-label">No</span>
												
												
												</label>

												{inter_true1?<div>
												
												<label>
													
												<input type="radio" 
														onClick={inter_yes}
														onChange={e => {setInternational_school(e.target.value);setLoadingBtn(false)}}  
														name="type1"
														value="YES"
														/><span className="new-previous-label">Yes</span>

												</label>
												</div>:null}
												{inter_true?<div>
												
												<label>
													
												<input type="radio"
														onClick={inter_yes} 
														onChange={e => {setInternational_school(e.target.value);setLoadingBtn(false)}}  
														name="type1"
														value="YES"
														checked
														/><span className="new-previous-label">Yes</span>

												
												</label>
												</div>:null}


												</Fragment>:null}


												{res.international_school === null || res.international_school === ''?
												<div>
													<label>
														
														<input type="radio" 
															onClick={inter_yes_null}
															name="type1"
															value="YES"
															// defaultValue={}
															onChange={e => {setInternational_school(e.target.value);setLoadingBtn(false)}}
															/><span className="new-previous-label">Yes</span>
													
													</label>
													
													<label>
														
														<input type="radio" 
															onClick={inter_no_null}
															name="type1"
															value="NO"
															// defaultValue={}
															onChange={e => {setInternational_school(e.target.value);setLoadingBtn(false)}} 
															/><span className="new-previous-label">No</span>
													
													</label>
												</div>:null}

												

												
											
											</div>

									</div>

								</div>

							</div>

							

							{/* Transfer Student Question - Add this before the "Was this student enrolled in your school LAST SCHOOL YEAR" question */}
							<div className="mb-5"></div> 






							{ res.international_school === "YES"?
							<div>
								{openInterSchoolForm?

									<div>
										<div className="mb-5"></div> 
										<label style={{fontSize: '14px'}}><a href="https://form.jotform.com/242205730389153">CLICK HERE</a> for the International Student Application Form</label>
									</div>

								:
									null
								}
							</div>:null
							}

							{ res.international_school === "NO"?
							<div>
								{openInterSchoolForm1?

									<div>
										<div className="mb-5"></div> 
										<label style={{fontSize: '14px'}}><a href="https://form.jotform.com/242205730389153">CLICK HERE</a> for the International Student Application Form</label>
									</div>

								:
									null
								}
							</div>:null
							}

						{ res.international_school === null?
							<div>
								{interformnull?
									<div>
										<div className="mb-5"></div> 
										<label style={{fontSize: '14px'}}><a href="https://form.jotform.com/242205730389153">CLICK HERE</a> for the International Student Application Form</label>
									</div>:null
								}
							</div>:null
							}



<div className="mb-5"></div> 

							<div className="form-group">
								<div className="row">
									<div className="col-md-6">
										<label>Is this an 8th grade student?<span style={{color: "red"}}>*</span></label>
										<div className="radio-btn-type"> 
										
										    <label>
												<input 
													type="radio" 
													name="is8thGrade"
													value="NO"
													checked={is8thGradeNo}
													onClick={handle8thGradeNo}
												/>
												<span className="new-previous-label">No</span>
											</label>
											<label>
												<input 
													type="radio" 
													name="is8thGrade"
													value="YES"
													checked={is8thGradeYes}
													onClick={handle8thGradeYes}
												/>
												<span className="new-previous-label">Yes</span>
											</label>
											
											
										</div>
										{is8thGradeError && (
											<div className="nerrors" style={{color:"red", fontSize: "12.8px"}}>
												Please select if this is an 8th grade student
											</div>
										)}
									</div>
								</div>
							</div>

							{is8thGrade === 'YES' && (
								<div className="form-group">
									<div className="row">
										<div className="col-md-12">	
											<label>Upload 8th Grade Document<span style={{color: "red"}}>*</span></label>	
											<div>
												<div className='file-input' style={{background:"#e6e8eaab", width:'100%'}}>
													<input 
														type='file' 
														onChange={(event) => {changeHandler8th(event.target.files[0]);}}  
													/>	
													<span className='button' style={{background:'dodgerblue', color:'#fff', fontWeight:'500', fontSize:'12px'}}>
														Choose
													</span>
													<span 
														className='labels' 
														style={{color: fileUrl8th ? 'dodgerblue' : 'gray', fontWeight:'500', fontSize:'12px'}} 
														data-js-label
													>
														{!fileSelect8th ? "No file selected" : fileSelect8th}
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							)}

							
							
							<div className="mb-5"></div>
						

							 <div className="form-group">
                                        
                                <div className="row">

                                    <div className="col-md-12">
                                            
									<label>Was this student enrolled in your school LAST SCHOOL YEAR ?<span style={{color: "red"}}>*</span></label>
                                            <div class="radio-btn-type">    
											{res.aes_status ==='NO'?
												<Fragment>
													<label>

														<input type="radio" 
															onClick={openType}  
															onChange={e => {setXfrType(e.target.value);setLoadingBtn(false)}} 
															checked={res.aes_status ==="NO"}
															name="lastschool"
															value="NO"/><span className="new-previous-label">Yes</span>

													</label>
												
												{noSelectXFR1?<div>
												<label>
													
												<input type="radio" 
													onClick={openSet}  
													onChange={e => {setXfrType(e.target.value);setLoadingBtn(false)}} 
													name="lastschool" 
													value="YES"/><span className="new-previous-label">No</span>
												</label>
												</div>:null}


												{noSelectXFR2?<div>

												<label>
												<input type="radio" 
												checked
													onClick={openSet}  
													onChange={e => {setXfrType(e.target.value);setLoadingBtn(false)}} 
													name="lastschool" 
													value="YES"/><span className="new-previous-label">No</span>
												</label>
												</div>:null}

											</Fragment>
												
												:null}







											{res.aes_status ==='YES'?
													<Fragment>

									<label>
												<input type="radio" 
													onClick={openSet}  
													checked = {res.aes_status === "YES"}
													name="lastschool" 
													onChange={e => {setXfrType(e.target.value);setLoadingBtn(false)}} 
													value="YES"/><span className="new-previous-label">No</span>
											
											</label>


											{yesSelectXFR1?<div>			
                                                <label>
                                                    <input type="radio" 
                                                        onClick={openType}  
                                                        name="lastschool"
                                                        onChange={e => {setXfrType(e.target.value);setLoadingBtn(false)}} 
                                                        value="NO"/><span className="new-previous-label">Yes</span>

                                                </label>
											</div>:null}

											{yesSelectXFR2?<div>			
                                                <label>
                                                    <input type="radio" 
                                                        onClick={openType} 
														checked 
                                                        name="lastschool"
                                                        onChange={e => {setXfrType(e.target.value);setLoadingBtn(false)}} 
                                                        value="NO"/><span className="new-previous-label">Yes</span>

                                                </label>
											</div>:null}

											</Fragment>:null


												
										}









                                                
                                                {/* <label>
                                                    
                                                    <input type="radio" 
                                                        // onClick={openSet}  
														checked={res.aes_status === 'NO'}
                                                        name="lastschool" 
                                                        onChange={e => {setType(e.target.value)}} 
                                                        value="NO"/><span className="new-previous-label">No</span>
                                                
                                                </label> */}

                                            
                                            </div>

                                    </div>

                                </div>

                            </div>
							
							
							
							{/*<div className="form-group">
								<div className="row">
									
									<div className="col-md-6">
										<label >School Name</label>
										<select className="form-control justshow bg-dark" onChange={e => {setSchoollast(e.target.value)}} >
											<option>Select School</option>
											{ schresult?.map((item,index)=>(
												<option key={index} value={item.id} selected={res.last_school === item.name}>{item.name}</option>
											)
											
											) }
											
										</select>
										
									</div>
									<div className="col-md-6">
										<label >Unlisted School Name</label>
										<input type="text" className="form-control justshow bg-dark" defaultValue={res.other_school} onChange={e => {setUnlistschoolname(e.target.value)}} placeholder="Enter Unlisted School Name" />
										
									</div>
									
									
									
								</div>
								
							</div>
							
							<div className="form-group">
								<div className="row">
									
									
									<div className="col-md-6">
										<label >Unlisted School City</label>
										<input type="text" className="form-control justshow bg-dark" defaultValue={res.other_city} onChange={e => {setUnlistschoolcity(e.target.value)}} placeholder="Enter Unlisted School City" />
										
									</div>
									
									<div className="col-md-6">
										<label >Unlisted School State</label>
										<input type="text" className="form-control justshow bg-dark" defaultValue={res.other_state} onChange={e => {setUnlistschoolstate(e.target.value)}} placeholder="Enter Unlisted School State" />
										
										
									</div>
									
									
									
								</div>
								
							</div> */}
							
							
							{/* <div className="form-group">
								<div className="row">
									
									
									<div className="col-md-6">
										<label >CSIET Approved Foreign Exchange Programs</label>
										<select className="form-control justshow bg-dark" onChange={e => {setCsiet(e.target.value)}}>
											<option>Select CSIET Programs</option>
											{ programresult?.map((item,index)=>(
												 item.type === 'CSIT' ? 
													(<option value={item.id} key={index} selected={res.csiet_foreign_exchange === item.id}>{item.name}</option>):null
												
												
											)
											
											)

											}
											
										</select>
										
									</div>
									
									<div className="col-md-6">
										<label >GISA Approved International Programs</label>
										<select className="form-control justshow bg-dark" onChange={e => {setGisa(e.target.value)}}>
										<option>Select GISA Programs</option>
											{ programresult?.map((item,index)=>(
												 item.type === 'GISA' ? 
													(<option value={item.id} key={index} selected={res.gisa_foreign_exchange === item.id}>{item.name}</option>):null
												
												
											)
											
											)

											}
										</select>
										
									</div>
									
									
									
								</div>
								
							</div> */}
							
							
							<div className="mb-5"></div>
							
							{/* <div className="form-group">
								<div className="row">
									
									
									<div className="col-md-12">
										<label >GISA Member School Attended anytime within the Last School Year</label>
										<div className="info">For example : Student attended a GISA member school , then transfered to public school, then transfered to GISA-member school WITHIN THE SAME SCHOOL YEAR</div>
									</div>
								</div>
								
							</div> */}

							{
								open ?
								
								<>

									<div className="mb-5"></div>
									<div className="form-group">
										<div className="row">

											<div className="col-md-12">

												<label >Where did the Student Transfer from ?</label>
													<div className="checkbox-wrpr">
														<select className="form-control bg-dark dark-theme showtext" onChange={e => {setStatus1(e.target.value);setLoadingBtn(false);}} id="status-selector">
															<option value="0">Where did the Student Transfer from ? </option>
															<option  selected={status1 === 'GISA/GIAA MEMBER SCHOOL'} >GISA/GIAA MEMBER SCHOOL</option>
															<option  selected={status1 === 'PUBLIC SCHOOL'}>PUBLIC SCHOOL</option>
															<option  selected={status1 === 'NON-MEMBER PRIVATE SCHOOL'}>NON-MEMBER PRIVATE SCHOOL</option>
															<option  selected={status1 === 'VIA CSIET-APPROVED EXCHANGE PROGRAM'} >VIA CSIET-APPROVED EXCHANGE PROGRAM</option>
															<option value="HOME SCHOOL"  selected={status1 === 'HOME SCHOOL'} >HOME SCHOOL - NOW FULLY ENROLLED</option>
															<option value="SEVP SCHOOL"  selected={status1 === 'SEVP SCHOOL'} >SEVP-CERTIFIED SCHOOL</option>
															<option value="AES SCHOOL"  selected={status1 === 'AES SCHOOL'} >AES SCHOOL</option>

														</select>
													</div>
											</div>

										</div>
									</div>
									
									{
										errorStatus1
										? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please select last school</div>
										:null
									}
								</>

							:

								null

							}
							

									{ 
										
										status1 === 'GISA/GIAA MEMBER SCHOOL' ?	

										<div className="form-group">
											<div className="row">
												<div className="col-md-6">
													<label >GISA/GIAA Schools {res.last_school} </label>
													<select	select className="form-control justshow bg-dark" onChange={e => { setSchoollast(e.target.value);setLoadingBtn(false)}}>
													<option>Select GISA/GIAA School  </option>
													{ schresult?.map((item,index)=>(
														<option key={index} value={item.id} selected={res.last_school === item.name}>{decode(item.name)}</option>
													)
													
													) }
													</select>
													{
														school_gisaerror
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter gisa school</div>
														:null
													}
												</div>

											</div>

										</div>
											
										:
											
											null
									}

								{ 
									
									status1 === 'PUBLIC SCHOOL' ?	

									<>

									<div className="form-group">
										<div className="row">

										<div className="col-md-6">
										<label>Public School Name </label>
										<input type="text" className="form-control justshow bg-dark" defaultValue={res.public_school_name} onChange={e => {setPublic_school_name(e.target.value)}}  placeholder="Enter Public school name" />
									{/* {
										lnameerror
										? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Public school name</div>
										:null
									} */}
									{/* {lnameexist?<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{lnameexist}</div>:null}
									
										{
										school_gisaerror
										? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter gisa school</div>
										:null
									} */}
									{
										homeSchoolError
										? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Public school name</div>
										:null
									}
										</div>

										<div className="col-md-6">
											<label >City </label>
											<input type="text" className="form-control justshow bg-dark" defaultValue={res.public_city} onChange={e => {setPublic_city(e.target.value)}}  placeholder="Enter City" />
										
										{
												homeCityError
												? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Public school city</div>
												:null
											}
										</div>

										</div>
									</div>
										
									
									<div className="form-group">
										<div className="row">
											<div className="col-md-6">
												<label >State </label>
												<input type="text" className="form-control justshow bg-dark" defaultValue={res.public_state} onChange={e => {setPublic_state(e.target.value)}}  placeholder="Enter State" />
												{
												homeStateError
												? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Public school state</div>
												:null
											}
											</div>

											<div className="col-md-6">
												<label >Country </label>
												<input type="text" className="form-control justshow bg-dark" defaultValue={res.public_country} onChange={e => {setPublic_country(e.target.value)}}  placeholder="Enter Country" />
											{
												homeCountryError
												? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Public school coutry</div>
												:null
											}
											</div>
										</div>
									</div>

									</>
										
									:
										
										null
									}

								{ 
									
									status1 === 'NON-MEMBER PRIVATE SCHOOL' ?	

									<>

										<div className="form-group">
											<div className="row">
										
												<div className="col-md-6">
													<label >Private School Name </label>
													<input type="text" className="form-control justshow bg-dark" defaultValue={res.private_school_name} onChange={e => {setPrivate_school_name(e.target.value)}}  placeholder="Enter school name" />
												
													{
														homeSchoolError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Non-member private school name</div>
														:null
													}
												</div>

												<div className="col-md-6">
													<label >City </label>
													<input type="text" className="form-control justshow bg-dark" defaultValue={res.private_city} onChange={e => {setPrivate_city(e.target.value)}}  placeholder="Enter City" />
													{
														homeCityError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Non-member private school city</div>
														:null
													}
												</div>

											</div>
										</div>

										<div className="form-group">
											<div className="row">

												<div className="col-md-6">
													<label >State </label>
													<input type="text" className="form-control justshow bg-dark" defaultValue={res.private_state} onChange={e => {setPrivate_state(e.target.value)}}  placeholder="Enter State" />
												{
													homeStateError
													? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Non-member private school state</div>
													:null
												}
												</div>

												<div className="col-md-6">
													<label >Country </label>
													<input type="text" className="form-control justshow bg-dark" defaultValue={res.private_country} onChange={e => {setPrivate_country(e.target.value)}}  placeholder="Enter Country" />
												{
												homeCountryError
												? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Public school coutry</div>
												:null
												}
												</div>
											</div>
										</div>

									</>
										
									:
										
										null
									}

								{ 
									
									status1 === 'HOME SCHOOL' ?	

									<>

										<div className="form-group">
											<div className="row">
										
												<div className="col-md-6">
													<label >Home School Name </label>
													<input type="text" className="form-control justshow bg-dark" defaultValue={res.home_school} onChange={e => {setHome_school(e.target.value)}}  placeholder="Enter school name" />
													{
														homeSchoolError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Home school name</div>
														:null
													}
												</div>

												<div className="col-md-6">
													<label >City </label>
													<input type="text" className="form-control justshow bg-dark" defaultValue={res.home_city} onChange={e => {setHome_city(e.target.value)}}  placeholder="Enter City" />
													{
														homeCityError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Home school city</div>
														:null
													}
												</div>

											</div>
										</div>

										<div className="form-group">
											<div className="row">

												<div className="col-md-6">
													<label >State </label>
													<input type="text" className="form-control justshow bg-dark" defaultValue={res.home_state} onChange={e => {setHome_state(e.target.value)}}  placeholder="Enter State" />
													{
														homeStateError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Home state city</div>
														:null
													}
												</div>

												<div className="col-md-6">
													<label >Country </label>
													<input type="text" className="form-control justshow bg-dark" defaultValue={res.home_country} onChange={e => {setHome_country(e.target.value)}}  placeholder="Enter Country" />
													{
														homeCountryError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Home country city</div>
														:null
													}
												</div>
											</div>
										</div>

									</>
										
									:
										
										null
									}

									{ 
									
									status1 === 'VIA CSIET-APPROVED EXCHANGE PROGRAM' ?
									
										<div className="form-group">
											<div className="row">

												<div className="col-md-6">
													<label >VIA CSIET-APPROVED  EXCHANGE PROGRAM </label>
													<select	select className="form-control justshow bg-dark" onChange={e => {setCsiet(e.target.value)}}>
													<option>Select CSIET-APPROVED EXCHANGE PROGRAM<span style={{color: "red"}}>*</span></option>
													{ 
														programresult?.map((item,index)=>{
														if (item.type === "CSIT") {
															return (
														<option key={index} value={item.id} selected={res.csiet_foreign_exchange.id === item.id}>{item.name}</option>)
														}
													}
													
													) }
													</select>
													{
														school_gisaerror
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter CSIET</div>
														:null
													}
												</div>

											</div>
										</div>
										
									:
										
										null
								}







									{ 
										
										status1 === 'SEVP SCHOOL' ?	

										<>

											<div className="form-group">
												<div className="row">
											
													<div className="col-md-6">
														<label >SEVP-CERTIFIED School Name </label>
														<input type="text" className="form-control justshow bg-dark" defaultValue={res.sevp_school} onChange={e => {setSevp_school(e.target.value);setLoadingBtn(false);setSchoollast(0)}}  placeholder="Enter school name" />
														{
														sevpSchoolError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter SEVP-CERTIFIED school name</div>
														:null
													}
													</div>


													<div className="col-md-6">
														<label >SEVP-CERTIFIED School City </label>
														<input type="text" className="form-control justshow bg-dark" defaultValue={res.sevp_city} onChange={e => {setSevp_city(e.target.value);setLoadingBtn(false)}}  placeholder="Enter City" />
														{
														sevpCityError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter SEVP-CERTIFIED school city</div>
														:null
													}
													</div>



												</div>
											</div>

											<div className="form-group">
												<div className="row">

													<div className="col-md-6">
														<label >SEVP-CERTIFIED School State </label>
														<input type="text" className="form-control justshow bg-dark" defaultValue={sevp_state} onChange={e => {setSevp_state(e.target.value);setLoadingBtn(false)}}  placeholder="Enter State" />
														{
														sevpStateError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter SEVP-CERTIFIED school city</div>
														:null
														}
													</div>


													<div className="col-md-6">
														<label >SEVP-CERTIFIED School Country </label>
														<input type="text" className="form-control justshow bg-dark" defaultValue={sevp_country} onChange={e => {setSevp_country(e.target.value);setLoadingBtn(false)}}  placeholder="Enter Country" />
														{
														sevpCountryError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter SEVP-CERTIFIED school country</div>
														:null
														}
													</div>

												</div>
											</div>

										</>
											
										:
											
										null
									}




								{
								status1 === 'AES SCHOOL' ?
								
								<div>

								<div className="form-group">
								<div className="row">

									<div className="col-md-6">
										<label>AES School Name</label>
										<input type="text" className="form-control justshow bg-dark" defaultValue={aesname} onChange={e => {setAesName(e.target.value);setLoadingBtn(false)}}  placeholder="Enter Name" />
										{
										aesNameError
										? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter AES School Name</div>
										:null
										}
									</div>


									<div className="col-md-6">
										<label >AES School City </label>
										<input type="text" className="form-control justshow bg-dark" defaultValue={aescity} onChange={e => {setAesCity(e.target.value);setLoadingBtn(false)}}  placeholder="Enter City" />
										{
										aesCityError
										? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter AES School City</div>
										:null
										}
									</div>

								</div>
								</div>

								<div className="form-group">

								<div className="row">

									<div className="col-md-6">
										<label >AES School State </label>
										<input type="text" className="form-control justshow bg-dark" defaultValue={aesstate} onChange={e => {setAesState(e.target.value);setLoadingBtn(false)}}  placeholder="Enter State" />
										{
										aesStateError
										? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter AES School city</div>
										:null
										}
									</div>


									<div className="col-md-6">
										<label >AES School Country </label>
										<input type="text" className="form-control justshow bg-dark" defaultValue={aescountry} onChange={e => {setAesCountry(e.target.value);setLoadingBtn(false)}}  placeholder="Enter Country" />
										{
										aesCountryError
										? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter AES School country</div>
										:null
										}
									</div>

								</div>

								</div>
								</div>

								:
									null
								}

<div className="mb-5"></div>
							<div className="form-group">
								<div className="row">
									<div className="col-md-6">
										<label>Is this student a transfer student?<span style={{color: "red"}}>*</span></label>
										<div className="radio-btn-type">    
											<label>
												<input 
													type="radio" 
													name="isTransferStudent"
													value="YES"
													checked={isTransferStudentYes}
													onClick={handleTransferStudentYes}
												/>
												<span className="new-previous-label">Yes</span>
											</label>
											
											<label>
												<input 
													type="radio" 
													name="isTransferStudent"
													value="NO"
													checked={isTransferStudentNo}
													onClick={handleTransferStudentNo}
												/>
												<span className="new-previous-label">No</span>
											</label>
										</div>
										{isTransferStudentError && (
											<div className="nerrors" style={{color:"red", fontSize: "12.8px"}}>
												Please select if this is a transfer student
											</div>
										)}
									</div>
								</div>
							</div>

							<div className="form-group">
								<div className="row">
									<div className="col-md-12">	
										<label >Upload Document</label>	
										<div>
											<div class='file-input' style={{background:"#e6e8eaab", width:'100%'}}>
											<input type='file' onChange={(event)=>{changeHandler(event.target.files[0]);}}  />	
											<span class='button' style={{background:'dodgerblue', color:'#fff', fontWeight:'500', fontSize:'12px'}}>Choose</span>
											<span class='labels' style={{color:fileUp?'dodgerblue':'gray', fontWeight:'500', fontSize:'12px' }} data-js-label>{!fileSelect?"No file selected":fileSelect}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
								
								
							<div className="form-group">
								<div className="row">

									

									<div className="col-md-6">
										<label >Notes</label>
										<textarea type="text" className="form-control justshow bg-dark" defaultValue={res.notes} onChange={e => {setNotes(e.target.value)}}  placeholder="Enter Notes" />
									</div>
								</div>								
							</div>
							<div className="form-group">
								<div className="row">
									
									{/* { status === 'INACTIVE' ?	
										<div className="col-md-6">
											<label >Inactive Reason </label>
											<div className="checkbox-wrpr">
												<select className="form-control bg-dark dark-theme showtext" onChange={e => {setInactive(e.target.value)}} id="status-selector">
													<option value="0">Select Reason</option>
													<option value="Did not PASS enough credits this semester">Did not PASS enough credits this semester</option>
													<option value="Student is not competing in any sports">Student is not competing in any sports</option>
												</select>
											</div>	
										</div>:null
									} */}


									

								</div>
							</div>
							<h6 style={{color: "red"}}>* Required Fields</h6>
							<div className="form-group">
								<div className="row">
									<div className="col-md-6">
										<label >&nbsp; </label>
										<div className="checkbox-wrpr">
											<input type="checkbox" 
												onChange={checkCofirm}
												className="form-control justshow bg-dark" />
											<div class="chckc">
											By checking this box, I confirm that the information entered above is true and accurate. I also confirm that this student has NOT attended another GISA/GIAA Member School within the last 12 months. 
											</div>
										</div>	
										
									</div>
									
									
									
									
									
								</div>
								
							</div>
							
							
							
							
							<div className="form-group text-right">
							<button className="btn btn-danger btn-gisa" onClick={RoutToList} type="submit">Cancel</button>
								{checkCofirmbtn?
								<Fragment>									
								{agee < 20?
										<Fragment>
										{loadingBtn?
											<button onClick={onEditELigibility} disabled className="btn btn-primary btn-gisa" type="button">Loading</button>:
											<button onClick={onEditELigibility} className="btn btn-primary btn-gisa" type="button">Update</button>
										}
									</Fragment>:
										<button onClick={ageError} className="btn btn-primary btn-gisa" type="button">Update</button>
								}
								</Fragment>:
								<button onClick={onEditELigibility} disabled className="btn btn-primary btn-gisa" type="button">Update </button>
								}
							</div>
							

						</div>
					</div>
					
				</div>



                </div>
            </aside>
        </div>
    )
    
}

export default EditAthlet;
